import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendCustomDataset, BackendMutationUpdateCustomModelArgs } from 'src/types/backend';

import { CUSTOM_DATASET_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation UpdateCustomModel($customModelId: ID!, $isDefault: Boolean) {
    updateCustomModel(customModelId: $customModelId, isDefault: $isDefault) {
      ...CustomDataset
    }
  }
  ${CUSTOM_DATASET_FRAGMENT}
`;

type Variables = BackendMutationUpdateCustomModelArgs;
type Result = BackendCustomDataset;

export const updateCustomModel = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
